// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__B5rPV","subheading":"styles_subheading__UgVBv","firstWord":"styles_firstWord__cILEz"};